<template>
    <div class="auth">
        <div class="auth__content col-lg-6">
            <div class="content__inner">
                <img alt="logo" class="logo" :src="require('@/assets/img/logo.svg')"/>
                <amplify-sign-in
                        username-attributes="email"
                        v-bind:signInConfig="signInConfig">
                </amplify-sign-in>
            </div>
        </div>
        <div class="auth__background col-lg-6"
             :style="{backgroundImage:
             'url(' + require(`@/assets/img/auth_background.svg`) + ')' }"></div>
    </div>
</template>

<script>
    import {createPasswordToggleIcon} from '../../_utils/createPasswordToggleIcon'

    export default {
        name: "Login",
        data: () => ({
            signInConfig: {
                header: '',
                isSignUpDisplayed: false,
            },
        }),
        mounted() {
            createPasswordToggleIcon()
        }
    }
</script>

<style scoped>

</style>
